import React, { useEffect, useState } from "react";
import MapWrapper from "./components/map/mapWrapper";
import Header from "./components/header";
import HomePage from "./components/home/homePage";
import LoginUaePassCallback from "./components/LoginUaePassCallback";
import Contact from "./components/contact";
import LoginPage from "./components/login";
import ShowAddress from "./components/showAddress";
import PageNotFound from "./components/PageNotFound";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import "@esri/calcite-components/dist/calcite/calcite.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/vendor/animate.css/animate.min.css";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/remixicon/remixicon.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import "./assets/css/style.css";
import "./assets/css/splash-screen.css";
import axios from "axios";
import { useDispatch, connect } from "react-redux";
import {
  setAnonymousUser,
  setUserCredentials,
} from "./redux/actions/appSettingsActions";

import toast, { Toaster } from "react-hot-toast";
import { ToastProvider, useToasts } from "react-toast-notifications";

import { ThemeProvider } from "@material-ui/styles";
import theme from "./components/ui/Theme";

import { appConifg } from "./config/default";
import TimeOutHOC from "./components/TimeOutHOC";
import AlertDialog from "./components/AlertDialog";
import { CookiesProvider } from "react-cookie";
import ReactGA from "react-ga";

const LoadingMessage = () => {
  return (
    <div className="splash-screen">
      Wait a moment while we load your app....
      <div className="loading-dot">.</div>
    </div>
  );
};
function App() {
  // @udaya #For-MapOptions
  const [showMap, setShowMap] = useState(1);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let data = {};
    let axiosConfig = {
      headers: {
        username: appConifg.AnonymousUser.username,
        password: appConifg.AnonymousUser.password,
      },
    };
    axios
      .post(appConifg.Address.AddressApiUrl + "/Users/Login", data, axiosConfig)
      .then((response) => {
        console.log(response);
        if (response.data?.isSucceeded) {
          dispatch(
            setUserCredentials({ data: response.data.data, flag: false })
          );
          setIsLoading(false);
        } else {
          console.log("Error Login as Anonymous user");
          setIsLoading(false);
        }
      })
      .catch((ex) => {
        console.log(ex);
        setIsLoading(false);
      });
    ReactGA.initialize("UA-210379103-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return !isLoading ? (
    <ThemeProvider theme={theme}>
      <ToastProvider placement="top-center" autoDismiss={false}>
        <CookiesProvider>
          {/* below if for react hot toast toaster   */}
          <Toaster />
          <TimeOutHOC />
          <AlertDialog />
          <Router basename={appConifg.Address.SiteName}>
            <calcite-shell>
              <div slot="shell-header">
                <Header setShowMap={setShowMap} showMap={showMap} />
              </div>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={() => {
                    return <Redirect to="/Map" />;
                  }}
                />
                {/* This to hide Home page untill the content is ready */}
                {/* <Route path="/Home" component={HomePage} /> */}
                {/* #For-MapOptions */}
                <Route
                  path="/Map"
                  component={() => <MapWrapper showMap={showMap} />}
                />
                <Route path="/contact" component={Contact} />
                <Route path="/Address" component={ShowAddress} />
                <Route path="/Login" component={LoginPage} />
                {/* Uncomment to enable UAE Pass */}
                <Route
                  path="/LoginUaePassCallback"
                  component={LoginUaePassCallback}
                />
                <Route component={PageNotFound}></Route>
              </Switch>
            </calcite-shell>
          </Router>
        </CookiesProvider>
      </ToastProvider>
    </ThemeProvider>
  ) : (
    <LoadingMessage />
  );
}

export default App;
